import * as pdfjsLib from "pdfjs-dist";
import React, { useEffect, useRef, useState } from 'react';
import { screenFit } from '../../base/canvas/function';
import { getUserAgentType } from '../../base/util';
import { layoutType } from '../../video-layout-mode';


let userType;
pdfjsLib.GlobalWorkerOptions.workerSrc = `/libs/pdf.worker.min.js`;

export default function PDFViewer({
    focusUuid, focusIndex, uuid, page, pageIndex, elementHeight, elementWidth, scale, isWidthFit, canvasX, canvasY, refresh, 
    setCanvasWidth, setCanvasHeight, setLoadImage
}) {
    const currentRef = useRef();
    const [pageFit, setPageFit] = useState(isWidthFit);

    const [pdf, setPdf] = useState(null);
    const [prevPage, setPrevPage] = useState(null);

    useEffect(() => {
        userType = getUserAgentType();

        return(() => {
            if (pdf && pdf.destory) pdf.destory();
            setPdf(null);
        })
    }, []);

    const setImage = (imageWidth, imageHeight) => {
        let screenStyle = screenFit(elementWidth, elementHeight, imageWidth, imageHeight, isWidthFit);

        let fitCanvas = false;
        if (isWidthFit === undefined) {
            if (elementWidth < screenStyle.width || elementHeight < screenStyle.height) fitCanvas = true;
        } else {
            fitCanvas = isWidthFit;
        }  
        
        if (isWidthFit ? true : false !== fitCanvas) {
            screenStyle = screenFit(elementWidth, elementHeight, imageWidth, imageHeight, fitCanvas);
        } 

        setCanvasWidth(screenStyle.width);
        setCanvasHeight(screenStyle.height);
        return screenStyle;
    }

    const setCanvasPage = index => {
        try {
            if (index === null) {
                APP.UI.showLoading(false);
                return;
            }
            
            const canvasElement = document.getElementById("canvas_sd");
            pdf && pdf.getPage(index + 1).then(page => {
                const { width, height } = setImage(page.view[2], page.view[3]);
                
                let viewScale = 3.5;
                if (userType === layoutType.mobile) viewScale = 2.5;
                if (userType === layoutType.tablet) viewScale = 3;
                var viewport = page.getViewport({ scale: viewScale });

                var canvas = document.createElement("canvas");
                canvas.id = `canvas_${focusUuid}_${index}`;
                var context = canvas.getContext('2d');

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                var renderContext = {
                    canvasContext: context,
                    viewport
                };
                
                var renderTask = page.render(renderContext);
                renderTask.promise.then(() => {                    
                    const element = document.getElementById(`canvas_${focusUuid}_${focusIndex}`);
                    if (!element) {
                        canvasElement.appendChild(canvas);
                    }
                    setPdfPage(index);
                    setLoadImage(true);
                    APP.UI.showLoading(false);
                }).catch(() => {
                    APP.UI.showLoading(false);
                });
            });
        } catch (err) {
            
            APP.UI.showLoading(false);
        }        
    }

    const setDocument = () => {
        if (!page) return;
        
        if (prevPage !== focusUuid) {
            if (pdf && pdf.destory) pdf.destory();
            
            var loadingTask = pdfjsLib.getDocument({ url: `/docconv/get/${page}`, cMapUrl: '/cmaps/',  cMapPacked: true });
            loadingTask.promise.then((newPdf) => {
                setPrevPage( focusUuid );

                setPdf(newPdf);
            }); 
        }
        if (prevPage === focusUuid) {
            setPdfPage();
        }
    }
   
    useEffect(() => {
        APP.UI.showLoading(true);
        setPdf(null); 
        setLoadImage(false);    
        setDocument();   
    }, [focusUuid, page]);

    useEffect(() => {
        if (prevPage && prevPage === focusUuid) setPdfPage();
    }, [pdf, focusIndex, elementWidth, elementHeight, scale, isWidthFit, canvasX, canvasY, refresh]);


    const setPdfPage = () => {
        if (focusIndex !== null) {
            APP.UI.showLoading(true);
            const canvas = document.getElementById(`canvas_${focusUuid}_${focusIndex}`);
            if (canvas) {
                const context = currentRef.current.getContext("2d", { alpaha: false });
                const { width, height } = setImage(canvas.width, canvas.height); 
                currentRef.current.width = Math.min(width * scale, elementWidth);
                currentRef.current.height = Math.min(height * scale, elementHeight);
                
                context.drawImage(canvas, canvasX, canvasY, width * scale, height * scale);
                setLoadImage(true);

                APP.UI.showLoading(false);
            } else {
                setCanvasPage(focusIndex);
            }
        }        
    }

    return (
        <div className="page_container">
            <canvas id="pdf" ref={currentRef} />
        </div> 
    )
}